import { getAppConfig, patchAppConfig } from "@core/config";
import { useGetSettingsQuery } from "../settings";
import { AppSettings } from "@core/types";
import { useMemo } from "react";

const useConfig = (): AppSettings => {
  const { data: appSettings } = useGetSettingsQuery();

  return useMemo(() => {
    if (appSettings) {
      patchAppConfig(appSettings);
    }

    return getAppConfig();
  }, [appSettings]);
};

export default useConfig;
